import React, { useEffect, useState, useRef } from 'react';
import '../../common/css/reissueRequest.css';
import ReissuReservation from './reservationNumber/seatReservation';
import axios from 'axios';
import Cookies from 'js-cookie';
import SaveModal from '../modal/saveModal';

function SeatRequestPage() {
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);
    const [isCheck, setIsCheck] = useState(true);
    const [regAgentName, setRegAgentName] = useState('');
    const [regAgentPhone, setRegAgentPhone] = useState('');
    const [bank_name, setBankName] = useState('');
    const [reservations, setReservations] = useState([
        {
            air_pnr: '',
            pax_name: '',
            route: '',
            request_seat: '',
        },
    ]);

    const bankNameRef = useRef(null); // 가상계좌 은행명 input box 참조

    useEffect(() => {
        const axiosData = async () => {
            try {
                const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
            isLocal = true;
        } else {
            isLocal = false;
        }

                const response = await axios.get(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/seat/info`,
                    {
                        withCredentials: true,
                    },
                );
                setRegAgentName(response.data.userName);
                setRegAgentPhone(response.data.userPhone);
            } catch (error) {
                setModalContent(error?.response?.data?.message);
                setModalAction(() => () => (window.location.href = '/login'));
                setSaveStatus(false);            }
        };
        if (Cookies.get('isLogin')) {
            axiosData();
        } else {
            setModalContent('로그인 후 이용 가능한 서비스 입니다.');
            setModalAction(() => () => (window.location.href = '/login'));
            setSaveStatus(false);
        }
    }, []);

    const reservationAdd = () => {
        setReservations([
            ...reservations,
            {
                air_pnr: '',
                pax_name: '',
                route: '',
                request_seat: '',
            },
        ]);
    };

    // 예약 삭제
    const reservationRemove = () => {
        if (reservations.length > 1) {
            setReservations(reservations.slice(0, -1));
        }
    };

    // 입력 필드 변경 시 상태 업데이트
    const handleChange = (index, field, value) => {
        if (index === "bank_name") {
            setBankName(field);
        } else {
            setReservations(
                reservations.map((reservation, i) =>
                    i === index ? { ...reservation, [field]: value } : reservation,
                ),
            );
        }        
    };

    const handleSubmit = async () => {
        try {
            if (bank_name.trim() === "") {
                setModalContent('가상계좌 은행명을 입력해주세요.');
                setModalAction(() => () => setSaveStatus(true));
                setSaveStatus(false);

                // input box에 focus 주기
                if (bankNameRef.current) {
                    bankNameRef.current.focus();
                }
                return;
            }
            for (let i = 0; i < reservations.length; i++) {
                if (reservations[i].air_pnr === '') {
                    setModalContent('항공사 예약번호를 입력해주세요.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                } else if (reservations[i].pax_name === '') {
                    setModalContent('승객번호 및 승객명을 입력해주세요.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                } else if (reservations[i].route === '') {
                    setModalContent('노선을 입력해주세요.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                } else if (reservations[i].request_seat === '') {
                    setModalContent('요청 좌석을 입력해주세요.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                }
            }

            const hostname = window.location.hostname;
            let isLocal = null;
            if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
                isLocal = false;
            } else {
                isLocal = true;
            }

            await axios.post(
                `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/seat/request`,
                { bank_name, reservations, isCheck },
                {
                    withCredentials: true,
                },
            );

            window.location.href = '/service/seatList';

        } catch (error) {
            setModalContent(error.response.data.message);
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
        }
    };

    return (
        <div id='contents' className='contents'>
            <div class='subp_h_wrap'>
                <div class='subp_h_list subp_h_home'>
                    <div>서비스요청</div>
                    <div>ATR 발권 유료 좌석 요청</div>
                    <div>요청하기</div>
                </div>
            </div>
            <div className='page_hgroup'>
                <h2 className='title'>ATR 발권 유료 좌석 요청</h2>
            </div>
            <div className='table_wrap mb40'>
                <table
                    className='table_style4 bdt mb70'
                    cellPadding='0'
                    cellSpacing='0'
                    id='airCertInfoTbl'
                >
                    <colgroup>
                        <col style={{ width: '190px' }} />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>
                                <p className='essential'>담당자</p>
                            </th>
                            <td colSpan='3'>{regAgentName}</td>
                        </tr>
                        <tr>
                            <th>
                                <p className='essential'>휴대폰 번호</p>
                            </th>
                            <td colSpan='3'>
                                {regAgentPhone}
                                <label name='agreeSendSNS'>
                                    <input
                                        type='checkbox'
                                        name='agreeSendSNS'
                                        id='agreeSendSNS'
                                        className='agreeSendSNSInput'
                                        checked={isCheck}
                                        onClick={() => setIsCheck(!isCheck)}
                                    />
                                    답변등록 시 SMS 전송
                                </label>
                                <a className='editPhoneNum' href='/mypage'>
                                    (&nbsp;&nbsp;<i class='fa-solid fa-mobile-screen-button'></i>
                                    &nbsp;&nbsp;담당자 휴대폰번호 수정&nbsp;&nbsp;)
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p className='essential'>가상계좌 은행명</p>
                            </th>
                            <td colSpan='3'>
                                <input
                                    type='text'
                                    ref={bankNameRef}
                                    onChange={(e) => handleChange('bank_name', e.target.value)}
                                    value={bank_name}
                                    style={{ width: '370px' }}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className='btn_area reissue_area'>
                    <input
                        type='button'
                        id='plusPnrNum'
                        value='+ 예약번호 추가'
                        className='btn36 red sendAuthNumY mo-mt-btn'
                        style={{ height: '45px', lineHeight: 'unset' }}
                        onClick={reservationAdd}
                    />
                    <input
                        type='button'
                        id='minPnrNum'
                        value='- 예약번호 삭제'
                        className='btn36 red sendAuthNumY mo-mt-btn'
                        style={{ height: '45px', lineHeight: 'unset' }}
                        onClick={reservationRemove}
                    />
                </div>
                {reservations.map((data, index) => (
                    <ReissuReservation
                        num={index}
                        data={data}
                        key={index}
                        handleChange={handleChange}
                    />
                ))}
            </div>
            <div className='btn_area'>
                <input
                    type='button'
                    id='sendRequest'
                    value='유료 좌석 요청하기'
                    className='btn46 blue'
                    onClick={handleSubmit}
                    style={{ width: '260px' }}
                />
            </div>
            <div class='title_wrap mt70' style={{ justifyContent: 'flex-start' }}>
                <h4>ATR 발권 그룹 PNR 유료 좌석 구매 시 안내 사항</h4>
            </div>
            <table class='table_style3 bdt' cellpadding='0' cellspacing='0' id='privateInfoTbl'>
                <colgroup>
                    <col style={{ width: '100%' }} />
                </colgroup>
                <tbody>
                    <tr>
                        {/*prettier-ignore */}
                        <td className='infoTable' style={{padding:'10px'}}>
                            <strong>1. 비상구석의 경우, 신체 건강한 만 15세 이상 성인만 신청 가능합니다.</strong><br />
                            <span class="ml10"> (유/소아 동반 성인 승객 제외, 휠체어 신청 승객 이용 불가)</span><br />
                            <strong>2. 좌석 구매 후 환불 및 변경 양도 불가 합니다.</strong><br />
                            <strong>3. 구매 후 당일 공항 사정에 따라 기재 변경 등 지정 좌석이 변동될 수 있습니다.</strong><br />
                            <strong>4. 결제수단은 현금(계좌이체)만 가능합니다.</strong><br />
                            <strong>5. 요청 후 <span className='red' id='point' >결제시한은 당일 오후 3시</span>까지로 안내 됩니다. (오후 3시 이후 요청건은 익일 처리 될 수 있음)</strong><br />
                            <strong>6. 중복 및 반복 요청 제한하기 위하여 동일한 <span className='red' id='point' >중복 요청은 2회 이상 시한 내 미결제일 경우, 재 요청이 불가</span>합니다.</strong><br />
                            <strong>7. 무료 좌석 지정 요청은 불가합니다.</strong><br />
                            <strong>8. 요청은 <span className='red' id='point' >출발 하루 전 날 오후 2시까지 신청 가능</span>하며 임박할 경우 신청 불가합니다.</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
            <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
        </div>
    );
}

export default SeatRequestPage;
